// Shared toast singleton — works across all modules as long as ToastContainer is mounted in App.js
let _toastFn = null;

export const toast = {
    success: (msg) => _toastFn?.('success', msg),
    error: (msg) => _toastFn?.('error', msg),
    info: (msg) => _toastFn?.('info', msg),
    _register: (fn) => { _toastFn = fn; },
    _unregister: () => { _toastFn = null; },
};
